import { defineMessages } from 'react-intl-next';

export const messages: {
	next: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	previous: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	previous: {
		id: 'company-hub.cards-extension.row-orientation.previous',
		defaultMessage: 'Previous',
		description:
			'Label text for the button that, when clicked, goes back one card and displays the previous card',
	},
	next: {
		id: 'company-hub.cards-extension.row-orientation.next',
		defaultMessage: 'Next',
		description:
			'Label text for the button that, when clicked, goes forward one card and displays the next card',
	},
});
